import { FC, useEffect, useState } from 'react';
import { PageType } from 'interfaces/generic';
import { unsubscribeCommand } from 'services/get-data-level';
import { Skeleton } from 'newcomponents/UI/Skeleton';
import { useMounted } from 'hooks/useMounted';

type Props = {
  countGetter: Function;
  currentSport?: string;
  pageType?: PageType;
  category?: string;
};

export const StandaloneGamesCount: FC<Props> = ({
  countGetter,
  currentSport,
  pageType,
  category
}) => {
  const [count, setCount] = useState<null | number>(null);
  const [rid, setRid] = useState<null | string>(null);
  const [loading, setLoading] = useState(true);
  const { mounted } = useMounted();

  useEffect(() => {
    count !== null && setLoading(false);
  }, [count]);

  useEffect(() => {
    if (!rid || currentSport) {
      if (
        category === 'esport' &&
        count !== null &&
        (pageType === 'live' || pageType === 'prematch')
      ) {
        return;
      }

      setCount(null);
      setLoading(true);
      const returnedRid = countGetter((data: number | null) => {
        if (!mounted.current) {
          return;
        }

        setCount(data);
      }, currentSport);

      if (!rid) {
        setRid(returnedRid);
      }
    }

    return () => {
      rid && unsubscribeCommand(rid);
    };
  }, [rid, currentSport]);

  return loading ? (
    <Skeleton
      title={{
        style: {
          height: 24,
          width: 58,
          margin: '-4px -12px',
          borderRadius: 8
        }
      }}
      paragraph={false}
      active
    />
  ) : (
    <span>{count}</span>
  );
};
